import {axios} from '../../services/axios';

export default async function getAvailableRegionsFromACompany(companyId) {
    return axios
        .get(`/Services/SBCaaS/Company/${companyId}/Regions/Available`)
        .then((res) => res)
        .catch((e) => e);
}
